import { CSSObject } from "@emotion/react";
import {
  type AnchorStyleOverrides,
  type ButtonStyleOverrides,
  constants,
  typographyStyles,
} from "@newsela/angelou";

const { heading6Obj, textSObj } = typographyStyles;

const optionLayoutCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "0.5rem",
};

const optionCss: CSSObject = {
  ...textSObj,
  width: "100%",
  padding: "0 0.5rem",
  borderRadius: "0.5rem",
  color: constants.colors.ui.black[700],

  ":hover": {
    background: "#F1F7FF",
  },

  svg: {
    width: "1rem",
    height: "1rem",

    path: {
      fill: constants.colors.ui.neutral[700],
    },
  },
};

export const accountOptionsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "1rem 0.5rem",
  gap: "1rem",
};

export const accountOptionsTitleCss: CSSObject = {
  ...heading6Obj,
  fontWeight: 700,
  padding: "0 0.5rem",
  color: constants.colors.ui.black[700],
  margin: 0,
};

export const accountOptionsUnorderedListCss: CSSObject = {
  margin: 0,
  padding: 0,
  width: "100%",
  listStyleType: "none",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",

  li: {
    textAlign: "left",
  },
};

export const accountOptionButtonCss: ButtonStyleOverrides<CSSObject> = {
  root: { ...optionCss, ...optionLayoutCss },
};

export const accountOptionAnchorCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    ...optionCss,
    textDecoration: "none",

    "> div": {
      ...optionLayoutCss,
      color: constants.colors.ui.black[700],
    },
  },
};
